import { Modal } from '@carboncopyco/ui';
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import { useFocusAppService } from '../../hooks/useFocusAppService';
import { useFocusModalAppService } from '../../hooks/useFocusModalAppService';
import { useTabs } from '../../store/context';

interface ModalProps {
  isVisible: boolean;
  onCloseModal?: () => void;
  children: any;
  isCenterPosition?: boolean;
  removeCloseIcon?: boolean;
  locked?: boolean;
  noPadding?: boolean;
  noBackground?: boolean;
  containerClass?: string;
  closeOnlyFromCloseIcon?: boolean;
  onClose?: () => void;
  zIndex?: number;
  title?: string;
  isAppInFocus?: boolean;
}

const ModalWrapper = ({
  isVisible,
  onCloseModal,
  children,
  isCenterPosition = false,
  noBackground = false,
  removeCloseIcon = false,
  containerClass = '',
  zIndex,
  isAppInFocus,
  ...rest
}: ModalProps) => {
  const { hideOpenDropdown } = useFocusAppService();
  useFocusModalAppService(isVisible, isAppInFocus);

  // Handling showing/hiding and focusing/blurring the app if related tab is active or not
  const { activeGlobalTabId } = useTabs();
  const relatedTabId = useRef<number>(activeGlobalTabId);
  const isRelatedTabActive = relatedTabId.current === activeGlobalTabId;

  useEffect(() => {
    if (isRelatedTabActive) {
      hideOpenDropdown();
    }
  }, [activeGlobalTabId]);

  if (!isVisible || !isRelatedTabActive) return null;

  if (isCenterPosition) {
    return (
      <Modal
        containerClass={containerClass || 'w-ds-md-modal'}
        open={isVisible}
        noBackground={noBackground}
        removeCloseIcon={removeCloseIcon}
        zIndex={zIndex}
        {...rest}
      >
        {React.cloneElement(children, { ...onCloseModal })}
      </Modal>
    );
  }

  return <>{React.cloneElement(children, { ...onCloseModal })}</>;
};

export default ModalWrapper;
